import { RiProfileFill } from "react-icons/ri";
import { BsFilePersonFill, BsFillGeoAltFill } from "react-icons/bs";
import { IoTicketSharp } from "react-icons/io5";
import "../Css/Global.css";
import { HiClipboardDocumentList } from "react-icons/hi2";
import { HiChartSquareBar, HiDocumentReport } from "react-icons/hi";
import { TbReportAnalytics } from "react-icons/tb";
import { MdPolicy, MdTextSnippet } from "react-icons/md";
import { ImAttachment } from "react-icons/im";

export const adminItems = [
  {
    label: "SOP",
    key: "sop",
    icon: (
      <div className="nav-menu-icon">
        <ImAttachment />
      </div>
    ),
  },
  {
    label: "Employees Verification",
    key: "employees-verification",
    icon: (
      <div className="nav-menu-icon">
        <BsFilePersonFill />
      </div>
    ),
  },
  {
    label: "Employees Master",
    key: "employees-manager",
    icon: (
      <div className="nav-menu-icon">
        <BsFilePersonFill />
      </div>
    ),
  },

  // {
  //     label: "Employees Manager",
  //     key: "employees-manager",
  //     icon: <div className="nav-menu-icon"><BsFillGeoAltFill /></div>,
  //     children: [
  //         {
  //             label: "Employees",
  //             key: "employees-manager/employees",
  //             icon: <div className="nav-menu-icon"><BsFilePersonFill /></div>,
  //         }]
  // },
  {
    label: "Geo Tagging",
    key: "geo-tag",
    icon: (
      <div className="nav-menu-icon">
        <BsFillGeoAltFill />
      </div>
    ),
    children: [
      {
        label: "Employees",
        key: "geo-tag/employees",
        icon: (
          <div className="nav-menu-icon">
            <BsFilePersonFill />
          </div>
        ),
      },
      {
        label: "Documentation",
        key: "documentation",
        icon: (
          <div className="nav-menu-icon">
            <ImAttachment />
          </div>
        ),
      },
      {
        label: "Report",
        key: "geo-tag/report",
        icon: (
          <div className="nav-menu-icon">
            <HiDocumentReport />
          </div>
        ),
      },
    ],
  },
  // {
  //   label: "Notification",
  //   key: "notification",
  //   icon: (
  //     <div className="nav-menu-icon">
  //       <BsFilePersonFill />
  //     </div>
  //   ),
  // },
  {
    label: "Mediclaim",
    key: "mediclaimHr",
    icon: (
      <div className="nav-menu-icon">
        <BsFilePersonFill />
      </div>
    ),
  },

  // {
  //     label: "Policies & SOPs",
  //     key: "company-policies",
  //     icon: <div className="nav-menu-icon"><HiClipboardDocumentList /></div>,
  //     children: [{
  //         label: "SOP",
  //         key: "company-policies/sop",
  //         icon: <div className="nav-menu-icon"><MdTextSnippet /></div>,
  //     }, {
  //         label: "Policies",
  //         key: "company-policies/policies",
  //         icon: <div className="nav-menu-icon"><MdPolicy /></div>,
  //     }, {
  //         label: "Escalation Matrix",
  //         key: "company-policies/escalation-matrix",
  //         icon: <div className="nav-menu-icon"><HiChartSquareBar /></div>,
  //     }]
  // },
  // {
  //     label: 'Manage Tickets',
  //     key: 'manage-tickets',
  //     icon: <div className="nav-menu-icon"><IoTicketSharp /></div>,
  // }
  // {
  //     label: "Pre Onboarding",
  //     key: "pre-onboarding",
  //     icon: <div className="nav-menu-icon"><RiProfileFill /></div>,
  // },
  // {
  //     label: "Attendance",
  //     key: "attendance",
  //     icon: <div className="nav-menu-icon"><IoCalendarSharp /></div>,
  // },
];

export const userItems = [
  {
    label: "Dashboard",
    key: "dashboard",
    icon: (
      <div className="nav-menu-icon">
        <RiProfileFill />
      </div>
    ),
  },
  //   {
  //   label: "Attendence",
  //   key: "attendence",
  //   icon: (
  //     <div className="nav-menu-icon">
  //       <RiProfileFill />
  //     </div>
  //   ),
  // },
  // {
  //   label: "Mediclaim",
  //   key: "Employee",
  //   icon: (
  //     <div className="nav-menu-icon">
  //       <RiProfileFill />
  //     </div>
  //   ),
  // },
  // {
  //     label: "Profile",
  //     key: "profile",
  //     icon: <div className="nav-menu-icon"><RiProfileFill /></div>,
  // },
  // {
  //     label: "Attendance",
  //     key: "attendance",
  //     icon: <div className="nav-menu-icon"><IoCalendarSharp /></div>,
  // },
  // {
  //     label: "Policies & SOPs",
  //     key: "company-policies",
  //     icon: <div className="nav-menu-icon"><HiClipboardDocumentList /></div>,
  //     children: [{
  //         label: "SOP",
  //         key: "company-policies/sop",
  //         icon: <div className="nav-menu-icon"><MdTextSnippet /></div>,
  //     }, {
  //         label: "Policies",
  //         key: "company-policies/policies",
  //         icon: <div className="nav-menu-icon"><MdPolicy /></div>,
  //     }, {
  //         label: "Escalation Matrix",
  //         key: "company-policies/escalation-matrix",
  //         icon: <div className="nav-menu-icon"><HiChartSquareBar /></div>,
  //     }]
  // },
  // {
  //     label: 'Ticket',
  //     key: 'ticket',
  //     icon: <div className="nav-menu-icon"><IoTicketSharp /></div>,
  // }
];

export const newUserItems = [
  {
    label: "Employee Joining Form",
    key: "new-user",
    icon: (
      <div className="nav-menu-icon">
        <RiProfileFill />
      </div>
    ),
  },
];
